export default "__VITE_ASSET__CgHgVnzC__"